<template>
  <img :src="src" class="document-image" :alt="alt" />
</template>

<script setup lang="ts">
defineProps<{
  src: string;
  alt: string;
}>();
</script>

<style>
.document-image {
  display: block;
  object-fit: contain;
  margin-left: auto;
  margin-right: auto;
}
</style>
